import { createContext, ReactNode, useContext } from "react";
import { useInvestmentTransaction } from "../hooks/useVpsTransaction";

const InvestmentTransactionContext = createContext<
  ReturnType<typeof useInvestmentTransaction> | undefined
>(undefined);

// Custom hook to use the context
export const useInvestmentTransactionContext = () => {
  const context = useContext(InvestmentTransactionContext);
  if (!context) {
    throw new Error(
      "useInvestmentTransaction must be used within InvestmentTransactionProvider"
    );
  }
  return context;
};

export const InvestmentTransactionProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const value = useInvestmentTransaction();
  return (
    <InvestmentTransactionContext.Provider value={value}>
      {children}
    </InvestmentTransactionContext.Provider>
  );
};
